import { DialogContent } from "./DialogContent";
import { Theme } from "@mui/material/styles";
import { Card } from "./Card";
import { Dialog } from "./Dialog";
import { Drawer } from "./Drawer";
import { Grid } from "./Grid";
import { Paper } from "./Paper";
import { Table } from "./Table";
import { SvgIcon } from "./SvgIcon";
import { TabPanel } from "./TabPanel";
import { Autocomplete } from "./Autocomplete";

export const overrideComponents = (theme: Theme) => {
  return Object.assign(
    Autocomplete(theme),
    SvgIcon(theme),
    Card(theme),
    Dialog(theme),
    DialogContent(theme),
    Drawer(theme),
    Grid(theme),
    Paper(theme),
    Table(theme),
    TabPanel(theme),
  );
};
